import classNames from "classnames";
import React, { useContext, useEffect, useState } from "react";
import {
  RicosAlignmentContextProvider,
  RicosNodeContextProvider,
  RicosViewerContext
} from "./../../ricos-context/index.js";
import { CollapsibleListData_InitialExpandedItems } from "./../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { ROOT } from "../data-hooks.js";
import classes from "../statics/styles/collapsible-list-component-scss.js";
import { getAlignmentFromDirection } from "../utils.js";
import { CollapsibleListContextProvider } from "./collapsible-list-context.js";
const CollapsibleList = ({
  node,
  nodeIndex,
  RicosNodesRenderer,
  NodeViewContainer
}) => {
  const { initialExpandedItems, expandOnlyOne } = node.collapsibleListData || {};
  const computeExpandedItems = () => {
    if (initialExpandedItems === CollapsibleListData_InitialExpandedItems.ALL) {
      return (node.nodes || []).reduce((acc, curr) => ({ ...acc, [curr.id]: true }), {});
    }
    if (initialExpandedItems === CollapsibleListData_InitialExpandedItems.FIRST && node.nodes && node.nodes[0]) {
      return { [node.nodes[0].id]: true };
    }
    return {};
  };
  const [expandedItems, setExpandedItems] = useState(computeExpandedItems);
  useEffect(() => {
    setExpandedItems(computeExpandedItems());
  }, [initialExpandedItems, node.nodes?.length]);
  const toggle = (id) => {
    setExpandedItems((prev) => {
      const isExpanded2 = !!prev[id];
      if (expandOnlyOne) {
        return { [id]: !isExpanded2 };
      }
      return { ...prev, [id]: !isExpanded2 };
    });
  };
  const { isPrint } = useContext(RicosViewerContext);
  const isExpanded = (id) => !!isPrint || !!expandedItems[id];
  const direction = node.collapsibleListData?.direction?.toLowerCase() || "ltr";
  const alignment = getAlignmentFromDirection(direction);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex }, /* @__PURE__ */ React.createElement("div", { className: classNames(classes[direction], classes.listDimensions), "data-hook": ROOT }, /* @__PURE__ */ React.createElement(RicosAlignmentContextProvider, { textAlignment: alignment }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: node, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(CollapsibleListContextProvider, { isExpanded, toggle }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: node.nodes ?? [] }))))));
};
const CollapsibleListRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(CollapsibleList, { key: node.id, node, ...props });
};
var collapsible_list_default = CollapsibleListRenderer;
export {
  collapsible_list_default as default
};
//# sourceMappingURL=collapsible-list.js.map

import "@wix/ricos/css/plugin-collapsible-list-viewer.global.css";